<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col sm="9">
          <h1>Логи Уведомлений</h1>
        </v-col>
        <v-col sm="3" class="search-col">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
          no-data-text="Лог пустой"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :items="notificationLogs"
          :options.sync="options"
          :footer-props="footerProps"
          :server-items-length="total"
          :items-per-page="50"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :loading="loading"
          loading-text="Загрузка лога... Подождите пожалуйста"
      >

        <template v-slot:header.created_at>
          Дата создания<br>
          <v-btn  fab x-small outlined class="filter-button" :class="{active: filters.created_at.valueFrom || filters.created_at.valueTo}"
                 @click.stop.prevent="filters.created_at.modal = !filters.created_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.app_type>
          Приложение<br>
          <v-btn  fab x-small outlined class="filter-button" :class="{active: filters.app_type.valueFrom || filters.app_type.valueTo}"
                 @click.stop.prevent="filters.app_type.modal = !filters.app_type.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.version>
          Версия АПИ<br>
          <v-btn  fab x-small outlined class="filter-button" :class="{active: filters.app_type.valueFrom || filters.app_type.valueTo}"
                 @click.stop.prevent="filters.app_type.modal = !filters.app_type.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>


        <template v-slot:item.data="{ item }">
          <button  @click.stop.prevent="openPreview(item)" >посмотреть</button>
        </template>

      </v-data-table>
    </v-col>
    <v-overlay
        :z-index="4"
        :value="overlay"
    >
    </v-overlay>


    <v-dialog
        v-model="filters.created_at.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                  ref="createdAtValueFromModal"
                  v-model="filters.created_at.valueFromModal"
                  :return-value.sync="filters.created_at.tempValueFrom"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueFrom"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueFrom"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueFromModal.save(filters.created_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                  ref="createdAtValueToModal"
                  v-model="filters.created_at.valueToModal"
                  :return-value.sync="filters.created_at.tempValueTo"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueTo"
                      label="До"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueTo"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueToModal.save(filters.created_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setCreatedAtFilter">Выбрать</v-btn>

          <v-btn
              outlined
              @click="filters.created_at.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="filters.app_type.modal"
        max-width="600"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <div>
                <label class="typo__label">По приложению</label>
                <multiselect
                    :options="appTypes"
                    v-model="filters.app_type.value"
                    @input="appChange()"
                    track-by="id"
                    outlined
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder=""
                    label="text"
                    :preselect-first="false"
                    :taggable="false"
                >
                </multiselect>
              </div>
            </v-col>
            <v-col>


              <div>
                <label class="typo__label">По версии АПИ</label>
                <multiselect
                    :options="appVersionsFiltered"
                    v-model="filters.version.value"
                    track-by="id"
                    outlined
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder=""
                    label="text"
                    :preselect-first="false"
                    :taggable="false"
                >
                </multiselect>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppType">Выбрать</v-btn>

          <v-btn
              outlined
              @click="filters.app_type.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="selectedItem.modal"
        max-width="600"
        v-if="selectedItem.item"
    >
      <v-card>
        <v-card-title>
          Предпросмотр
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <div class="preview">
                <div class="img">
                  <img v-if="selectedItem.item.preview.image" :src="selectedItem.item.preview.image" alt="preview">
                  <img v-if="!selectedItem.item.preview.image" src="@/assets/noImage.jpg" alt="preview">
                </div>
              </div>
              <table class="table">
                <tr>
                  <th>Поле</th>
                  <th>Значение</th>
                </tr>
                <tr>
                  <td>Title</td>
                  <td>{{selectedItem.item.title}}</td>
                </tr>
                <tr>
                  <td>Text</td>
                  <td>{{selectedItem.item.text}}</td>
                </tr>
                <tr v-for="key in selectedItem.item.previewKeys">
                  <td>{{dataLabels[key] ? dataLabels[key] : key}}</td>
                  <td v-html="dataValues[key] ? dataValues[key](selectedItem.item.preview[key], dataValuesSupport) : selectedItem.item.preview[key] || 'нет'"></td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>

          <v-btn
              outlined
              @click="closePreview()"
          >
            Закрыть
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        right
        top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
// @ is an alias to /src

import ProductService from './../../api/ProductService'
import CategoryService from './../../api/CategoryService'
import TagService from './../../api/TagService'
import NotificationService from "@/api/NotificationService";
import moment from 'moment'
import Multiselect from "vue-multiselect";
import {BtnTypesHelper} from "../../helpers/btn-types.helper";

export default {
  name: 'NotificationLogIndex',
  components: {
    Multiselect
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
    statuses: [],
    filters: {
      created_at: {
        valueFrom: '',
        valueFromModal: false,
        valueTo: '',
        valueToModal: false,
        tempValueFrom: '',
        tempValueTo: '',
        modal: false,
      },
      version: {
        value: [],
        finalValue: [],
        modal: false,
      },
      app_type: {
        value: [],
        modal: false,
        finalValue: [],
        valueMadal: false,
      }
    },
    selectedItem: {
      item: null,
      modal: false
    },
    appTypes: [
      {
        id: 'ios',
        text: 'IOS'
      },
      {
        id: 'android',
        text: 'Android'
      },
    ],
    appVersions: [],
    appVersionsFiltered: [],
    snackbarText: '',
    snackbarColor: '',
    overlay: false,
    loading: false,
    phoneQuery: null,
    notificationLogs: [],
    total: 0,
    timerId: null,
    search: '',
    options: {},
    footerProps: {
      itemsPerPageText: 'Элементов на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [15]
    },
    dataLabels: {
      image: 'Картинка',
      btn_url: 'Ссылка',
      btn_text: 'Текст кнопки (рус)',
      btn_text_ua: 'Текст кнопки (укр)',
      btn_type: 'Тип Кнопки',
      product: 'Товар',
      category: 'Категория',
    },
    dataValues: {
      image: (url) => url ? `<a target="_blank" href="${url}">link</a>` : 'нет',
      btn_type: (type) => BtnTypesHelper.TYPES.find(item => item.id === type)?.text || type,
      category: (id, support) => support.categories.find(item => item.id === +id)?.name || id,
      product: (id, support) => support.currentProductName || 'loading...',
    },
    dataValuesSupport: {
      categories: [],
      currentProductName: null,
    },
    headers: [
      {
        text: 'Дата создания', value: 'created_at',
      },
      {
        text: 'Дата отправки', value: 'send_date',
      },
      {
        text: 'Title', value: 'title'
      },
      {
        text: 'Text', value: 'text'
      },
      {
        text: 'ОС', value: 'app_type'
      },
      {
        text: 'Версия АПИ', value: 'version'
      },
      {
        text: 'Номера телефонов', value: 'number'
      },
      {
        text: 'Количество просмотров', value: 'viewed_count'
      },
      {
        text: 'Уведомление на почту и в систему', value: 'tokensCount'
      },
      {
        text: 'Только системное уведомление', value: 'disabledTokensCount'
      },
      {
        text: 'Ошибка FCM', value: 'failed_count'
      },
      {
        text: 'Предпросмотр', value: 'data', sortable: false
      }
    ],
  }),
  mounted() {
    let url = new URL(document.documentURI);
    let searchParams = new URLSearchParams(url.search);
    this.search = searchParams.get('phone')
    this.getDataFromApi();


    CategoryService.list({
      show_disabled: true
    }).then(response => {
      this.dataValuesSupport.categories = response.data
    });

    NotificationService.getFormDetails().then(response => {

      this.appVersionsFiltered = this.appVersions = [ ...response.data.versions.map(item => ({
        text: item.app_version,
        id: item.app_version,
      }))];

    });

  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search() {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.getDataFromApi()
      }, 700)
    }
  },
  methods: {
    openPreview(item) {

      const selectedItem = item;
      selectedItem.preview = item.data ? JSON.parse(item.data) : {};

      this.dataValuesSupport.currentProductName = null;

      if (selectedItem.preview.product) {
        ProductService.get(selectedItem.preview.product).then(response => {

          this.dataValuesSupport.currentProductName = response.data?.name || 'ID: ' + selectedItem.preview.product;

        }).catch(err => {

          this.dataValuesSupport.currentProductName = 'не удалось загрузить';
        });
      }

      selectedItem.previewKeys = Object.keys(selectedItem.preview);

      this.selectedItem.item = selectedItem;

      this.selectedItem.modal = true;
    },
    closePreview() {
      this.selectedItem.modal = false;
    },
    appChange() {
      if (this.filters.app_type.value.length === 1) {
        const isIOS = this.filters.app_type.value[0].id === 'ios';

        const exp = isIOS ? /ios/i : /and/i;

        this.appVersionsFiltered = this.appVersions.filter((item) => {
          return exp.test(item.text);
        });

        this.filters.version.value = this.filters.version.value.filter((item) => {
          return exp.test(item.text);
        });
      } else {
        this.appVersionsFiltered = this.appVersions;
      }
    },
    setCreatedAtFilter(e) {
      this.filters.created_at.valueTo = this.filters.created_at.tempValueTo
      this.filters.created_at.valueFrom = this.filters.created_at.tempValueFrom

      this.filters.created_at.modal = false;
      this.getDataFromApi();
    },
    setAppType(e) {
      console.log( this.filters.app_type.value);
      this.filters.app_type.finalValue = this.filters.app_type.value.map(item => item.id);
      this.filters.version.finalValue = this.filters.version.value.map(item => item.id);
      this.filters.app_type.modal = false;
      this.getDataFromApi();
    },
    getDataFromApi() {
      if (this.loading) return;
      this.loading = true

      const params = {
        page: this.options.page,
        search: this.search,
        createdAtFrom: this.filters.created_at.valueFrom,
        createdAtTo: this.filters.created_at.valueTo,
        app_type: this.filters.app_type.finalValue,
        version: this.filters.version.finalValue,
        sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
        sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
      }

      NotificationService.log(params)
          .then(response => {
            this.notificationLogs = response.data.data.map((item) =>
                ({...item,
                  created_at: moment(item.created_at).format('YYYY MM DD, hh:mm:ss'),
                  send_date: moment(item.send_date || item.created_at).format('YYYY MM DD, hh:mm:ss'),
                })
            );
            this.total = response.data.total

            this.loading = false
          }).catch(err => {
        console.error(err);
        this.loading = false;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

span.v-btn {
  border-color: currentColor !important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }


  &.v-card--link:focus::before {
    opacity: 0;
  }
}


.preview .img {
  text-align: center;

  img {
    height: 120px;
  }
}

.table {
  width: 100%;
  td, th {
    padding: 10px 5px;
    line-height: 12px;
    height: auto !important;
    text-align: left;

    &:nth-child(2) {
      text-align: right;
    }
  }
}

</style>

<style lang="scss">

.multiselect__content-wrapper {
  position: fixed !important;
  width: 300px !important;
}

</style>